module.exports = __webpack_public_path__ + "img/300_21.e78f5a1f.jpg";